import { useSyncExternalStore } from 'react';
import {
  getConsentSnapshot,
  subscribeToConsent,
  type ConsentSnapshot,
} from '@/services/consent';

/**
 * Subscribe a component to the visitor's analytics-consent decision. Used by
 * the banner (to know whether to show) and by app.tsx (to send the page view
 * that was suppressed while consent was pending).
 */
export const useConsent = (): ConsentSnapshot =>
  useSyncExternalStore(subscribeToConsent, getConsentSnapshot, getConsentSnapshot);

export default useConsent;
